import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { HaModalService } from "@ha/ui/common";

import { PwaState } from "@ha/util/pwa";
import { Store } from "@ngxs/store";
import { CommentDto } from "../../../models/permit-comments-dto";
import { PermitCommentRemoveModalComponent, PermitCommentRemoveModalComponentData } from "../permit-comment-remove-modal/permit-comment-remove-modal.component";

@Component({
    selector: "pmt-permit-comments-comment",
    templateUrl: "permit-comments-comment.component.html",
    styleUrls: ["permit-comments-comment.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PermitCommentsCommentComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input()
    public comment: CommentDto;

    @Input()
    public canDelete: boolean;

    @ViewChild("stepElement", { static: false })
    stepElement: ElementRef;

    @ViewChild("authorElement", { static: false })
    authorElement: ElementRef;

    @ViewChild("commentElement", { static: false })
    commentElement: ElementRef;

    @ViewChild("avatarElement", { static: false })
    avatarElement: ElementRef;

    public tooltipVisible = false;
    public isMobile = false;
    public hasExtendedMargin = false;

    private resizeListener: () => void;

    ngOnInit() {
        this.isMobile = this.store.selectSnapshot(PwaState.isMobile);
        this.setupResizeListener();
    }

    ngOnDestroy() {
        if (this.resizeListener) {
            window.removeEventListener("resize", this.resizeListener);
        }
    }

    ngAfterViewInit() {
        if (this.comment.step) {
            setTimeout(() => {
                this.adjustAuthorMargin();
            }, 100);
        }
    }

    private adjustAuthorMargin() {
        if (!this.stepElement || !this.authorElement || !this.comment.step) {
            return;
        }

        const mobileScreen = window.innerWidth <= 819;
        const margins = 65;
        const commentWidth = this.commentElement.nativeElement.offsetWidth;
        const avatarWidth = this.avatarElement.nativeElement.offsetWidth;
        const stepWidth = this.stepElement.nativeElement.offsetWidth;
        const authorWidth = this.authorElement.nativeElement.offsetWidth;

        const isMultiLine = (mobileScreen && commentWidth - margins <= avatarWidth + stepWidth + authorWidth)
            || (!mobileScreen && this.stepElement.nativeElement.offsetHeight > 22);

        if (isMultiLine) {
            this.hasExtendedMargin = true;
        } else {
            this.hasExtendedMargin = false;
        }

        this.cdr.detectChanges();
    }

    private setupResizeListener() {
        this.resizeListener = () => {
            const wasMobile = this.isMobile;
            this.isMobile = this.store.selectSnapshot(PwaState.isMobile);

            if (this.comment.step && this.stepElement && this.authorElement) {
                setTimeout(() => {
                    this.adjustAuthorMargin();
                }, 150);
            }

            if (wasMobile !== this.isMobile) {
                this.cdr.detectChanges();
            }
        };

        window.addEventListener("resize", this.resizeListener);
    }

    public showTooltip(event: MouseEvent) {
        if (!this.isMobile) {
            this.tooltipVisible = true;
        }
    }

    public hideTooltip() {
        if (!this.isMobile) {
            this.tooltipVisible = false;
        }
    }

    public toggleTooltipMobile(event: Event) {
        if (this.isMobile) {
            event.preventDefault();
            this.tooltipVisible = !this.tooltipVisible;
        }
    }

    constructor(private store: Store, private haModalService: HaModalService, private cdr: ChangeDetectorRef) {}

    public remove() {
        this.haModalService.open(
            PermitCommentRemoveModalComponent,
            true,
            <PermitCommentRemoveModalComponentData> { comment: this.comment },
        );
    }
}
